import { createContext, useState } from "react";

const LoaderContext = createContext({
  loading: false,
  setLoading: () => {},
});

const LoaderContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};

export { LoaderContext, LoaderContextProvider };
